import * as providerService from '@/services/providerService'

const STORAGE_KEY = 'provider.currentGeocontentId';

function readStoredGeocontentId() {
    var id = Number(localStorage.getItem(STORAGE_KEY));
    return id || null;
}

function writeStoredGeocontentId(id) {
    if (id) {
        localStorage.setItem(STORAGE_KEY, String(id));
    } else {
        localStorage.removeItem(STORAGE_KEY);
    }
}

function pickGeocontentId(geoContents, preferredId) {
    if (!geoContents || !geoContents.length) {
        return null;
    }
    if (preferredId && geoContents.some(gc => gc.id == preferredId)) {
        return Number(preferredId);
    }
    return geoContents[geoContents.length - 1].id;
}

const initialState = {
    provider: null,
    status: null,
    currentGeocontentId: null
}

export const provider = {
    namespaced: true,
    state: initialState,
    actions: {
        getProvider({
            dispatch,
            commit,
            state
        }) {
            commit('providerRequest');
            providerService.getProvider()
                .then(resp => {
                    var provider = resp.data;
                    if (provider) {
                        commit('providerSuccess', provider);
                        var geoContents = provider.geoContents || [];
                        var gcid = state.currentGeocontentId;
                        if (!gcid && geoContents.length) {
                            gcid = geoContents[geoContents.length - 1].id;
                        }
                        if (gcid) {
                            dispatch('chart/getChartCollection', null, {
                                root: true
                            })
                            dispatch('geoContent/getLicenses', gcid, {
                                root: true
                            })
                        }
                    } else {
                        commit('providerFailure', 'error.message');
                    }
                })
                .catch(error => {
                    commit('providerFailure', error.message);
                    dispatch('alert/error', error.message, {
                        root: true
                    });
                });
        },
        setCurrentGeocontentId({
            dispatch,
            commit
        }, geoContentId) {
            var gcid = Number(geoContentId);
            if (!gcid) {
                return;
            }
            commit('setCurrentGeocontentId', gcid);
            dispatch('chart/getChartCollection', null, {
                root: true
            })
            dispatch('geoContent/getLicenses', gcid, {
                root: true
            })
        }
    },
    mutations: {
        providerRequest(state) {
            state.status = {
                loading: true
            };
            state.provider = null;
        },
        providerSuccess(state, provider) {
            state.status = {
                loaded: true
            };
            state.provider = provider;
            var preferredId = state.currentGeocontentId || readStoredGeocontentId();
            var gcid = pickGeocontentId(provider.geoContents, preferredId);
            state.currentGeocontentId = gcid;
            writeStoredGeocontentId(gcid);
        },
        providerFailure(state) {
            state.status = null;
            state.provider = null;
        },
        setCurrentGeocontentId(state, geoContentId) {
            state.currentGeocontentId = geoContentId;
            writeStoredGeocontentId(geoContentId);
        }
    },
    getters: {
        gcid: state => {
            var geoContents = state.provider && state.provider.geoContents;
            return pickGeocontentId(geoContents, state.currentGeocontentId);
        },
        geoContent: state => {
            var geoContents = state.provider && state.provider.geoContents;
            if (!geoContents || !geoContents.length) {
                return null;
            }
            var gcid = pickGeocontentId(geoContents, state.currentGeocontentId);
            return geoContents.find(gc => gc.id == gcid) || null;
        }
    }
}